import React from "react";
import LiveImage from "../../../Imager/LiveImage";
import {
  useCameraCalibrationContext,
  ECameraCalibrationType,
} from "./CameraCalibrationContext";
import PixelSizeContent from "./PixelSizeContent";
import { ImagerCalibration } from "../../../../Model/ImagerCalibration";

type Props = {
  imagerIdentifier: string;
  setIsCalibrationUpdated: (isCalibrationUpdated: boolean) => void;
  showDrawLine: boolean;
};

export default function CameraCalibrationContent({
  imagerIdentifier,
  setIsCalibrationUpdated,
  showDrawLine, 
}: Props) {
  const cameraCalibrationContext = useCameraCalibrationContext();

  return (
    <>
      {cameraCalibrationContext.calibration.cameraCalibrationType !==
        ECameraCalibrationType.PixelSize && (
        <LiveImage imagerIdentifier={imagerIdentifier} style={{ borderTop: "1px solid #B4B4B4", borderLeft: "1px solid #B4B4B4"}}/>
      )}
      {cameraCalibrationContext.calibration.cameraCalibrationType ===
        ECameraCalibrationType.PixelSize && (
        <PixelSizeContent
          imagerIdentifier={imagerIdentifier}
          setIsCalibrationUpdated={setIsCalibrationUpdated}
          showDrawLine={showDrawLine}
        />
      )}
    </>
  );
}
